module.exports = __webpack_public_path__ + "static/img/3areaB_14.f6dc919.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_14.png
// module id = 1156
// module chunks = 1